/* eslint-disable */
import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import { Container } from '@material-ui/core';
import { Typography } from 'antd';
import useAppSearchParams from 'src/hooks/useAppSearchParams';
import { COLOR_2 } from 'src/constants/ChartConstant';

const SNBLAccountCreationSuccessful: React.FC = () => {
  const {
    queryParamsObject: { accountName, accountNumber, bankName, userId },
  } = useAppSearchParams();

  return (
    <Container
      maxWidth="sm"
      style={{ marginTop: 80, textAlign: 'center', gap: '0.5rem', height: '100vh' }}
      className="d-flex flex-direction-column mx-auto align-items-center justify-center w-100"
    >
      <CheckCircleFilled color="success" style={{ color: COLOR_2, fontSize: 96 }} />
      <Typography.Title>Account Creation Successful</Typography.Title>
      <div>
        <p style={{ lineHeight: 1 }} className="py-0">
          Your account infomation will be sent to you shortly via sms.
        </p>
        <p style={{ lineHeight: 1 }} className="py-0">
          Please use it to make deposits at any time.
        </p>
      </div>
      {/* <Descriptions size="small">
        <Descriptions.Item label="Account name">{accountName}</Descriptions.Item>
        <Descriptions.Item label="Account number">{accountNumber}</Descriptions.Item>
        <Descriptions.Item label="Bank Name">{bankName}</Descriptions.Item>
      </Descriptions> */}
    </Container>
  );
};

export default SNBLAccountCreationSuccessful;
